import {HttpClient} from '@angular/common/http';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogCommentComponent} from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-comment/dialog-comment.component';
import {CommentService} from '../services/comment.service';

@Component({
  selector: 'adf-txt-viewer',
  templateUrl: './txtViewer.component.html',
  styleUrls: ['./txtViewer.component.scss'],
  host: { class: 'adf-txt-viewer' },
  encapsulation: ViewEncapsulation.None
})
export class TxtViewerComponent implements OnInit, OnChanges {
  @Input() elementId: string;
  @Input() parentId: string;
  @Input() fileName: string;
  @Input()
  urlFile: any;

  @Input()
  blobFile: Blob;
  @Input()
  isPublic: boolean;

  @Output()
  exit = new EventEmitter();

  content: string;
  public commentaire: string;
  public comments: any[];

  constructor(
    private http: HttpClient,
    private commentService: CommentService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.comments = [];
    this.commentService.getAllComment(this.elementId).then(res => {
      this.comments = res.items;
    });
  }

  ngOnChanges(changes: SimpleChanges): Promise<any> {
    const blobFile = changes['blobFile'];
    if (blobFile && blobFile.currentValue) {
      return this.readBlob(blobFile.currentValue);
    }

    const urlFile = changes['urlFile'];
    if (urlFile && urlFile.currentValue) {
      return this.getUrlContent(urlFile.currentValue);
    }

    if (!this.urlFile && !this.blobFile) {
      throw new Error('Attribute urlFile or blobFile is required');
    }
  }

  private getUrlContent(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(url, { responseType: 'text' }).subscribe(
        res => {
          this.content = res;
          resolve('');
        },
        event => {
          reject(event);
        }
      );
    });
  }

  private readBlob(blob: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        this.content = reader.result.toString();
        resolve('');
      };

      reader.onerror = (error: any) => {
        reject(error);
      };

      reader.readAsText(blob);
    });
  }

  public comment() {
    const dialogRef = this.dialog.open(DialogCommentComponent, {
      width: '40%',
      height: '30%',
      data: {
        elementId: this.elementId
      }
    });
  }
}
